import { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card } from "@/components/ui/card";
import { Lock, ShieldCheck } from "lucide-react";
import { toast } from "sonner";

export default function Login() {
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);
    const { login } = useAuth();

    const submit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            await login(password);
            toast.success("Connexion réussie");
        } catch (err) {
            toast.error(err?.response?.data?.detail || "Mot de passe incorrect");
        }
        setLoading(false);
    };

    return (
        <div className="min-h-screen w-full flex items-center justify-start relative overflow-hidden">
            <div
                aria-hidden
                className="absolute inset-0 -z-20 bg-cover bg-center scale-105"
                style={{
                    backgroundImage:
                        'url("https://customer-assets-eiarnc6j.emergentagent.net/job_inventory-dash-91/artifacts/hm2ruhni_dddd.webp")',
                    filter: "blur(4px)",
                }}
            />
            <div
                aria-hidden
                className="absolute inset-0 -z-10"
                style={{
                    background:
                        "linear-gradient(rgba(46,58,34,0.78), rgba(29,38,22,0.72))",
                }}
            />
            <div className="w-full max-w-md ml-6 sm:ml-16 lg:ml-24 mr-6">
                <div className="mb-8 text-white">
                    <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-[#B8934A]/20 border border-[#C8A75C]/40 text-xs uppercase tracking-widest font-semibold text-[#F0E0B0]">
                        <ShieldCheck className="w-3.5 h-3.5" /> Accès sécurisé
                    </div>
                    <h1 className="font-mc text-4xl sm:text-5xl font-semibold tracking-tight mt-4">
                        Stock - Raza Perdida
                    </h1>
                    <p className="text-slate-300 mt-2 text-sm sm:text-base">
                        Gestion de l&apos;inventaire et du stock
                    </p>
                </div>

                <Card className="p-8 rounded-xl border border-slate-200 shadow-sm bg-white">
                    <form onSubmit={submit} className="space-y-5">
                        <div>
                            <Label
                                htmlFor="password"
                                className="text-xs font-semibold uppercase tracking-[0.15em] text-slate-500"
                            >
                                Mot de passe
                            </Label>
                            <div className="relative mt-2">
                                <Lock className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
                                <Input
                                    id="password"
                                    data-testid="login-password-input"
                                    type="password"
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    className="pl-9 h-11"
                                    placeholder="Entrez le mot de passe"
                                    autoFocus
                                    required
                                />
                            </div>
                        </div>
                        <Button
                            type="submit"
                            data-testid="login-submit-btn"
                            disabled={loading || !password}
                            className="w-full h-11 bg-[#3D4E2E] hover:bg-[#2E3A22] text-white active:scale-[0.98] transition-transform"
                        >
                            {loading ? "Connexion…" : "Se connecter"}
                        </Button>
                        <p className="text-xs text-slate-500 text-center pt-2">
                            Tu peux pas nous hacker
                        </p>
                    </form>
                </Card>
            </div>
        </div>
    );
}
